import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Breakpoint, Scrollable, Stack } from '@yonderland/andes-react';
import { useProductListerContext } from '../context/ProductListerContext';
import { ListerQuickLinkItem } from './ListerQuickLinkItem';
export const ListerQuickLinks = () => {
    const { quickLinks } = useProductListerContext();
    if (!(quickLinks && quickLinks.length > 0)) {
        return null;
    }
    const renderQuickLinks = () => (_jsx(Box, { paddingInline: { base: '4', lg: '0' }, children: _jsx(Stack, { gap: "2", children: quickLinks.map(quickLink => (_jsx(ListerQuickLinkItem, { quickLink: quickLink }, `quickLink_${quickLink.linkName}`))) }) }));
    return (_jsxs(_Fragment, { children: [_jsx(Breakpoint, { until: "lg", children: _jsx(Box, { marginInline: "-4", children: _jsx(Scrollable, { horizontal: true, scrollbarHidden: true, gradient: true, children: renderQuickLinks() }) }) }), _jsx(Breakpoint, { from: "lg", children: renderQuickLinks() })] }));
};
